import React, { useEffect, useState } from "react";

/** Premium animated countdown to a target ISO datetime — Days · Hours · Minutes · Seconds tiles. */
export default function CountdownTo({ target, label = "Countdown" }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!target) return null;
  const t = new Date(target);
  const diff = t - now;

  if (diff <= 0) {
    return (
      <div className="inline-flex items-center gap-4 border border-black/15 bg-white/70 backdrop-blur-md rounded-full px-5 py-2">
        <span className="h-2 w-2 rounded-full bg-red-500 animate-pulse" />
        <span className="text-[10px] uppercase tracking-[0.24em] text-zinc-500">Status</span>
        <span className="serif text-base text-black">Live Today</span>
      </div>
    );
  }

  const days = Math.floor(diff / 86_400_000);
  const hours = Math.floor((diff / 3_600_000) % 24);
  const mins = Math.floor((diff / 60_000) % 60);
  const secs = Math.floor((diff / 1000) % 60);
  const pad = (n) => String(n).padStart(2, "0");

  const Tile = ({ value, unit }) => (
    <div className="flex flex-col items-center px-3 sm:px-5">
      <div className="serif text-3xl sm:text-5xl tabular-nums leading-none text-black">{pad(value)}</div>
      <div className="text-[9px] uppercase tracking-[0.22em] text-zinc-500 mt-2">{unit}</div>
    </div>
  );

  return (
    <div className="inline-flex flex-col items-start gap-3">
      <div className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 flex items-center gap-2">
        <span className="h-2 w-2 rounded-full bg-[#A39171]" />{label}
      </div>
      <div className="flex items-center divide-x divide-zinc-200 border border-zinc-200 bg-white/70 backdrop-blur-md rounded-sm py-3">
        <Tile value={days} unit="Days" />
        <Tile value={hours} unit="Hours" />
        <Tile value={mins} unit="Minutes" />
        <Tile value={secs} unit="Seconds" />
      </div>
    </div>
  );
}
